import React from 'react';
import PropTypes from 'prop-types';
import renderHTML from 'react-render-html';
import * as items from '../Items';
import Collapse from '../../Global/Collapse/Collapse';
import Icon from '../../Global/Icons/Icon';
import ItemColorSelect from '../ItemColorSelect';

const DiagramCreatorPlayers = ({ activeColor, changeColor }) => (
  <Collapse
    show
    trigger={
      <div>
        Players <span className="text-grey">(drag)</span>
        <Icon name="arrow-down" size="m" fill="black" />
      </div>
    }
    content={
      <div className="sidebar-dropdown">
        <ItemColorSelect activeColor={activeColor} changeColor={changeColor} />

        <ul className="col-2">
          <li>
            <div style={{ fill: activeColor }} className="tool-drag player">
              <div id="player" className="tool-drag-svg">
                {renderHTML(items.PLAYER.svg)}
                <span className="tool-drag-trigger" />
              </div>
            </div>
          </li>

          <li>
            <div style={{ fill: activeColor }} className="tool-drag goalkeeper">
              <div id="goalkeeper" className="tool-drag-svg">
                {renderHTML(items.GOALKEEPER.svg)}
                <span className="tool-drag-trigger" />
              </div>
            </div>
          </li>

          <li>
            <div style={{ fill: activeColor }} className="tool-drag ussf-triangle-player">
              <div id="ussf_triangle_player" className="tool-drag-svg">
                {renderHTML(items.USSF_TRIANGLE_PLAYER.svg)}
                <span className="tool-drag-trigger" />
              </div>
            </div>
          </li>

          <li>
            <div style={{ fill: activeColor }} className="tool-drag ussf-circle-player">
              <div id="ussf_circle_player" className="tool-drag-svg">
                {renderHTML(items.USSF_CIRCLE_PLAYER.svg)}
                <span className="tool-drag-trigger" />
              </div>
            </div>
          </li>
        </ul>
      </div>
    }
  />
);

DiagramCreatorPlayers.propTypes = {
  activeColor: PropTypes.string,
  changeColor: PropTypes.func,
};

export default DiagramCreatorPlayers;



// WEBPACK FOOTER //
// ./library/app/components/Diagram/Tools/DiagramCreatorPlayers.js